import React from "react";
const HeroContainer = () => {
  return (
    <section className="hero-section moving section-padding" id="home">
      <div className="moving-bg"></div>
      <div className="floating-land">
        <img className="island"></img>
      </div>
      <div className="hero-section-content">
        <div className="container ">
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 col-md-12">
              <div className="welcome-content">
                <div className="promo-section">
                  <h3 className="special-head gradient-text">
                    Attack Wagon Games
                  </h3>
                </div>
                <h1>
                  Attack Wagon's Official{" "}
                  <span className="gradient-text">LAND SALE!</span>{" "}
                </h1>
                <p className="w-text">
                  Each land plot is an ERC-721 NFT utilizing Polygon network.
                  Landowners earn a portion of all fees taken from Attack
                  Wagon’s marketplace.
                </p>
                <div className="dream-btn-group">
                  <a href="https://quickswap.exchange/#/swap?outputCurrency=0xf868939ee81f04f463010bc52eab91c0839ef08c">
                    <button className="btn btn-Collect more-btn mr-3">
                      Buy $ATK
                    </button>
                  </a>
                  <a
                    rel="noopener noreferrer"
                    href="https://attackwagon.com/land"
                    target="_blank"
                  >
                    <button className="btn btn-explore more-btn">
                      Learn More ↗
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroContainer;
